import { useEffect, useState } from "react";
import {
  FaBath,
  FaBed,
  FaEnvelope,
  FaMapMarkerAlt,
  FaMountain,
  FaPhone,
  FaRegFrownOpen, // Icon untuk data kosong
  FaSearch,
  FaStar,
  FaUsers,
  FaWhatsapp // Icon tambahan untuk tombol WA agar makin cakep
} from "react-icons/fa";

import { Link, useLocation } from "react-router-dom";
import API_BASE_URL from "../config";
import "./css/Villas.css";

/* KOMPONEN FOOTER */
function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section footer-left">
          <h2>Permata Wisata</h2>
          <span>Jogja Tourism</span>
          <p>Your trusted partner for villa and homestay bookings in Jogja.</p>
        </div>
        <div className="footer-section footer-center">
          <h3>Contact Us</h3>
          <p><FaEnvelope /> info@permatawisata.com</p>
          <p><FaPhone /> +62 812-3456-7890</p>
        </div>
        <div className="footer-section footer-right">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <span className="social-icon">IG</span>
            <span className="social-icon">FB</span>
          </div>
        </div>
      </div>
      <div className="footer-divider" />
      <div className="footer-bottom">
        &copy; 2026 Permata Wisata. All rights reserved.
      </div>
    </footer>
  );
}

/* SKELETON LOADER COMPONENT (Biar Berkelas) */
const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-img pulse"></div>
    <div className="skeleton-info">
      <div className="skeleton-line pulse" style={{ width: '80%' }}></div>
      <div className="skeleton-line pulse" style={{ width: '60%' }}></div>
      <div className="skeleton-line pulse" style={{ width: '40%' }}></div>
    </div>
  </div>
);

function Villas() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const locationQuery = params.get("location") || "";
  const guestQuery = params.get("guests") || "";

  const [villas, setVillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("recommended");
  const [search, setSearch] = useState(locationQuery);
  const [type, setType] = useState("all");
  const [guestFilter, setGuestFilter] = useState("");
  const [nearby, setNearby] = useState("");
  
  /* TAMBAHAN STATE UNTUK MENDETEKSI SCROLL NAVBAR */
  const [isScrolled, setIsScrolled] = useState(false);

  /* TAMBAHAN EFEK UNTUK MEMANTAU SCROLL LAYAR */
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/villas`)
      .then(res => {
        if (!res.ok) throw new Error('Server tidak merespons');
        return res.json();
      })
      .then(data => {
        setVillas(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("ERROR FETCH:", err);
        setLoading(false);
      });
  }, []);

  const filtered = villas.filter(villa => {
    const matchSearch = villa.name?.toLowerCase().includes(search.toLowerCase()) || 
                        villa.location?.toLowerCase().includes(search.toLowerCase());
    const matchType = type === "all" || (type === "promo" && villa.promo) || villa.type === type;
    const matchGuest = guestQuery === "" || villa.guests >= parseInt(guestQuery);
    const matchGuestFilter = guestFilter === "" || villa.guests >= parseInt(guestFilter);
    const matchNearby = nearby === "" || (
        (nearby === "malioboro" && villa.location?.toLowerCase().includes("yogyakarta")) ||
        (nearby === "prambanan" && villa.location?.toLowerCase().includes("sleman"))
    );
    return matchSearch && matchType && matchGuest && matchGuestFilter && matchNearby;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sort === "low") return a.price - b.price;
    if (sort === "high") return b.price - a.price;
    return b.rating - a.rating;
  });

  return (
    <div className="villa-page">
      {/* NAVBAR DENGAN DETEKSI KELAS SCROLLED OTOMATIS */}
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <div className="logo-icon"><FaMountain /></div>
          <div className="logo-text">
            <h3>Permata Wisata</h3>
            <span>Jogja Tourism</span>
          </div>
        </div>
        <div className="nav-menu">
          <Link to="/">Home</Link>
          <Link to="/villas" className="active">Villas</Link>
          <a href="https://wa.me/081216687367" className="contact-btn">Contact Us</a>
        </div>
      </nav>

      <header className="villas-hero">
         <div className="hero-content">
            <h1>Eksplorasi Penginapan Terbaik</h1>
            <p>Temukan ketenangan di setiap sudut Yogyakarta</p>
            <div className="search-bar-modern">
                <FaSearch className="search-icon-inside" />
                <input 
                  type="text" 
                  placeholder="Cari nama villa atau lokasi..." 
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
            </div>
         </div>
      </header>

      <main className="container">
        {/* TYPE FILTER */}
        <div className="filter-wrapper">
            <div className="type-pills">
              {["all", "villa", "homestay", "pool", "promo"].map((t) => (
                <button 
                  key={t}
                  className={type === t ? "pill active" : "pill"} 
                  onClick={() => setType(t)}
                >
                  {t.charAt(0).toUpperCase() + t.slice(1)}
                </button>
              ))}
            </div>

            <div className="dropdown-filters">
              <select value={guestFilter} onChange={(e) => setGuestFilter(e.target.value)}>
                <option value="">Kapasitas Tamu</option>
                <option value="2">2+ Tamu</option>
                <option value="4">4+ Tamu</option>
                <option value="8">8+ Tamu</option>
              </select>

              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                <option value="recommended">Urutkan: Terbaik</option>
                <option value="low">Harga Terendah</option>
                <option value="high">Harga Tertinggi</option>
              </select>
            </div>
        </div>

        {/* GRID SECTION */}
        <section className="villa-grid">
          {loading ? (
            Array(6).fill(0).map((_, i) => <SkeletonCard key={i} />)
          ) : sorted.length === 0 ? (
            <div className="no-results">
              <FaRegFrownOpen size={50} />
              <h3>Maaf, Villa tidak ditemukan</h3>
              <p>Coba ubah kata kunci atau filter Anda.</p>
              <button onClick={() => {setSearch(""); setType("all")}}>Reset Filter</button>
            </div>
          ) : (
            sorted.map((villa) => (
              <div className="luxury-card" key={villa.id}>
                {/* Bagian Atas Kartu Dibungkus Link ke Detail Villa */}
                <Link to={`/villas/${villa.id}`} className="card-link-wrapper">
                  <div className="card-image">
                    {/* BAGIAN FOTO LOGIKA DINAMIS SINKRONISASI ASSET KAMU */}
                    <img 
                      loading="lazy"
                      src={`/images/villas/villa_${villa.id}/utama.png`} 
                      alt={villa.name} 
                      onError={(e) => {
                        e.target.src = "https://images.unsplash.com/photo-1572120360610-d971b9d7767c";
                      }}
                    />
                    {villa.promo === 1 && <div className="badge-promo">Special Offer</div>}
                    <div className="card-rating"><FaStar /> {villa.rating}</div>
                  </div>
                  
                  <div className="card-details">
                    <span className="villa-type-label">{villa.type}</span>
                    <h3>{villa.name}</h3>
                    <p className="loc"><FaMapMarkerAlt /> {villa.location}</p>
                    
                    <div className="amenities">
                      <span><FaUsers /> {villa.guests} Tamu</span>
                      <span><FaBed /> {villa.beds} Bed</span>
                      <span><FaBath /> {villa.baths} Bath</span>
                    </div>
                  </div>
                </Link>

                {/* Bagian Bawah Kartu: Harga & Tombol Aksi Katalog WhatsApp Asli */}
                <div className="card-footer-action" style={{ padding: '0 24px 24px 24px' }}>
                  <div className="card-footer" style={{ borderTop: '1px solid #eee', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="price-tag">
                      <span className="price-value">Rp {villa.price?.toLocaleString()}</span>
                      <span className="price-unit">/malam</span>
                    </div>
                    
                    {/* Tombol yang otomatis tersambung ke link katalog WA tiap villa */}
                    {villa.catalog_link && (
                      <a 
                        href={villa.catalog_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="wa-catalog-btn"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          backgroundColor: '#25D366',
                          color: '#fff',
                          padding: '8px 12px',
                          borderRadius: '6px',
                          textDecoration: 'none',
                          fontWeight: 'bold',
                          fontSize: '14px'
                        }}
                      >
                        <FaWhatsapp /> Katalog
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Villas;